import { API, graphqlOperation } from 'aws-amplify';
import { invokeCopyStepFunctions } from './graphql/mutations';

export const startCopyStepFunctions = async ({
  classId,
  submissionId,
  userId,
  recordingRoomId,
  cloudRecordings,
  startedAt,
  stoppedAt,
}) => {
  if (
    classId === undefined ||
    submissionId === undefined ||
    userId === undefined ||
    recordingRoomId === undefined ||
    cloudRecordings === undefined ||
    cloudRecordings.length === 0 ||
    startedAt == null ||
    stoppedAt == null
  ) {
    const error = new Error(
      'Missing one or more required parameters: classId, submissionId, userId, recordingRoomId, cloudRecordings, startedAt, stoppedAt'
    );
    console.error('Parameter validation failed:', error);
    throw error;
  }

  await API.graphql(
    graphqlOperation(invokeCopyStepFunctions, {
      input: {
        classId,
        submissionId,
        userId,
        recordingRoomId,
        cloudRecordings,
        startedAt,
        stoppedAt,
      },
    })
  );
};

